import styled from "styled-components";

export const HeaderActions = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;

  @media (min-width: 640px) {
    flex-direction: row;
    width: auto;
  }
`;

const baseActionButtonStyles = `
  align-items: center;
  border-radius: 1rem;
  border: 1px solid transparent;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 600;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.85rem 1rem;
  transition:
    transform 160ms ease,
    border-color 160ms ease,
    background 160ms ease,
    box-shadow 160ms ease;
  width: 100%;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const SecondaryHeaderButton = styled.button`
  ${baseActionButtonStyles}
  background: rgba(255, 255, 255, 0.04);
  border-color: var(--brand-border);
  color: var(--brand-ink);

  &:hover:not(:disabled) {
    border-color: var(--brand-highlight);
    background: rgba(240, 191, 86, 0.08);
  }
`;

export const PrimaryHeaderButton = styled.button`
  ${baseActionButtonStyles}
  background: var(--brand-highlight);
  color: #1b1306;

  &:hover:not(:disabled) {
    background: var(--brand-accent-deep);
    color: white;
  }
`;

export const StatsGrid = styled.div<{ $tight?: boolean }>`
  display: grid;
  gap: 1.25rem;
  margin-bottom: ${({ $tight }) => ($tight ? "0.75rem" : "2rem")};

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const HelperCardSlot = styled.div<{ $tight?: boolean }>`
  margin-top: ${({ $tight }) => ($tight ? "0.75rem" : "2rem")};
`;

export const ContentSlot = styled.div<{ $tight?: boolean }>`
  margin-top: ${({ $tight }) => ($tight ? "0.75rem" : "2rem")};
`;

export const EmbeddedHeaderBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
  width: 100%;
`;
